var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['z-share z-share--' + _vm.template, { active: _vm.active }],on:{"click":function($event){return _vm.toggleActive()}}})}
var staticRenderFns = []

export { render, staticRenderFns }